import type { ReactElement } from 'react';
import { CheckField, TextField } from '@ff-it/form';
import { Box } from '@ff-it/ui';
import { useFieldValue } from 'hooks';
import type { Bound, LinkerContext } from '../types';
import { resolveClientPONumber } from './poNumber';

export function PONumberField({ linkerContext }: { linkerContext: LinkerContext }): ReactElement {
  const useResolvedPO = useFieldValue<boolean>('_useResolvedPO');
  const bound = useFieldValue<Bound>('bound');
  const resolvedPO = resolveClientPONumber(linkerContext, bound || {});

  return (
    <Box display="flex" alignItems="flex-start" gap="3" mb="4" px="1" flexShrink={0} maxWidth="full">
      <Box width="14rem" minWidth="8rem" flexShrink={1}>
        <TextField
          name="client_po_number"
          aria-label="PO number"
          placeholder="PO number"
          size="sm"
          className="mb-0"
          readOnly={useResolvedPO}
          help={useResolvedPO ? null : 'Leave blank for no PO'}
        />
      </Box>
      <Box minWidth="0">
        <CheckField
          name="_useResolvedPO"
          variant="checkbox"
          size="md"
          fieldLabel={
            <Box as="span" fontSize="xs" style={{ overflowWrap: 'anywhere' }}>
              Use linked POs:{' '}
              <Box as="strong" fontWeight="semibold">
                {resolvedPO || 'None'}
              </Box>
            </Box>
          }
        />
      </Box>
    </Box>
  );
}
